package org.hs_soft.runmynesto.domain.usecase.home

import org.hs_soft.runmynesto.domain.repository.local_datasource.home.GetLanguageRepository

class GetLanguageUseCase(
    private val repository: GetLanguageRepository
) {
    suspend operator fun invoke():String{
        return repository.getLanguage()
    }


}